<template>
  <v-select
    class="small-text-field"
    :error-messages="errorMessages"
    :required="required"
    :value="content"
    :label="label"
    hide-details
    single-line
    solo
    :height="28"
    flat
    background-color="grey lighten-3"
  ></v-select>
</template>

<script>
export default {
  name: "SelectableInput",
  model: {
    prop: "content",
    event: "input"
  },
  props: {
    label: String,
    errorMessages: Object,
    required: { type: Boolean, default: true },
    content: String
  },
  data() {
    return {
      menu: false
    };
  },
  methods: {
    updateSelf(content) {
      this.menu = false;
      this.$emit("input", content);
      this.$emit("submitted");
      console.log("date selected");
    },
    focused() {
      console.log("focused");
      this.$emit("focused");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>
